'use strict';

const DEFAULT_ID_STR = '000';
const AL_ID_STR = '159';
const NL_ID_STR = '160';

export default {
    mappings: {
        // AL:
        5529: AL_ID_STR, // 4/5 Winner
        5528: AL_ID_STR, // 3/6 Winner
        5527: AL_ID_STR, // 2/7 Winner
        5526: AL_ID_STR, // 1/8 Winner
        5518: AL_ID_STR, // Div. Run Up (4)
        5519: AL_ID_STR, // Div. Run Up (5)
        5520: AL_ID_STR, // Div. Run Up (6)
        5513: AL_ID_STR, // Wild Card (8)
        4614: AL_ID_STR, // Div. Winner #1
        4615: AL_ID_STR, // Div. Winner #2
        4616: AL_ID_STR, // Div. Winner #3
        4944: AL_ID_STR, // Higher Seed
        4945: AL_ID_STR, // Lower Seed
        4612: AL_ID_STR, // Wild Card
        3370: AL_ID_STR, // TBD - DS 'A'
        3371: AL_ID_STR, // TBD - DS 'B'
        21: AL_ID_STR, // League Champion

        // NL:
        5533: NL_ID_STR, // 4/5 Winner
        5532: NL_ID_STR, // 3/6 Winner
        5531: NL_ID_STR, // 2/7 Winner
        5530: NL_ID_STR, // 1/8 Winner
        5522: NL_ID_STR, // Div. Run Up (4)
        5523: NL_ID_STR, // Div. Run Up (5)
        5524: NL_ID_STR, // Div. Run Up (6)
        5517: NL_ID_STR, // Wild Card (8)
        4617: NL_ID_STR, // Div. Winner #1
        4618: NL_ID_STR, // Div. Winner #2
        4619: NL_ID_STR, // Div. Winner #3
        4946: NL_ID_STR, // Higher Seed
        4947: NL_ID_STR, // Lower Seed
        4613: NL_ID_STR, // Wild Card
        3372: NL_ID_STR, // TBD - DS 'A'
        3373: NL_ID_STR, // TBD - DS 'B'
        31: NL_ID_STR, // League Champion

        // Generic: The two teams playing in the WS, _before_ we know which league's pennant winner will be the home
        // team (once known, team IDs 21 and 31 - see above - are used).  Not strictly necessary to map these to
        // DEFAULT_ID_STR because this is the default anyway; just being explicit:
        2710: DEFAULT_ID_STR, // League Champion #1
        2711: DEFAULT_ID_STR, // League Champion #2
    },
    defaultIdStr: DEFAULT_ID_STR,
    alIdStr: AL_ID_STR,
    nlIdStr: NL_ID_STR,
};
